export default __webpack_public_path__ + "static/media/client_three.68b52ce8.jpg";